import { Link, useLocation } from "react-router-dom";

const SUB_ITEMS = [
  { label: "企業情報トップ", path: "/company" },
  { label: "代表挨拶", path: "/company/message" },
  { label: "役員紹介", path: "/company/officers" },
  { label: "会社概要", path: "/company/overview" },
  { label: "経営理念", path: "/company/philosophy" },
  { label: "アクセス", path: "/company/access" },
];

export default function CompanySubNav() {
  const location = useLocation();

  return (
    <div className="w-full border-b border-background-200 bg-background-50">
      <nav
        aria-label="企業情報ナビゲーション"
        className="flex w-full gap-8 overflow-x-auto px-6 md:gap-10 md:px-12 lg:justify-center lg:px-20"
      >
        {SUB_ITEMS.map((item) => {
          const isActive = location.pathname === item.path;
          return (
            <Link
              key={item.path}
              to={item.path}
              className={`relative whitespace-nowrap py-5 font-body text-[13px] tracking-[0.1em] transition-colors ${
                isActive ? "text-foreground-950" : "text-foreground-500 hover:text-foreground-900"
              }`}
            >
              {item.label}
              <span
                className={`absolute bottom-0 left-0 h-px w-full origin-left bg-accent-500 transition-transform duration-300 ${
                  isActive ? "scale-x-100" : "scale-x-0"
                }`}
              />
            </Link>
          );
        })}
      </nav>
    </div>
  );
}